import axios from 'axios';
import * as actionTypes from '../constants/actions';
import { push } from 'redux-router';

import baseUrl from '../utils/baseUrl';
let url = baseUrl + '/api/basic/';

function action(type) {
	return { type: type };
};

function respond(json, type) {
	//console.log(type);
	return {
		type: type,
		payload: json,
	};
};

export function fetchPage(slug) {
	if (!(typeof slug === 'number' || (typeof slug === 'string' && slug.length))) {
		console.log('editorials - invalid slug');
		return function(dispatch) {
			dispatch(push('/error'));
		};
	}

	//console.log('fetch single editorial - ' + url + slug);

	return function(dispatch) {
		dispatch(action(actionTypes.PAGES_REQ_SINGLE_DATA));
		return axios({
			url: url + slug,
			timeout: __TIMEOUT__ || 10000,
			method: 'get',
			responseType: 'json',
		})
		.then(function(response) {
			dispatch(respond(response.data, actionTypes.PAGES_RECV_SINGLE_DATA));
		})
		.catch(function(response) {
			dispatch(respond(response.data, actionTypes.PAGES_RECV_ERROR));

			// console.log('Page - fetch error');
			// console.log(response);

			dispatch(push('/error'));
		});
	};
}



/** WEBPACK FOOTER **
 ** ./frontend/actions/page.js
 **/